'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPhoneInTalk = function MdPhoneInTalk(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 20q0-2-1.5-3.5t-3.5-1.5v-3.4q3.4 0 5.9 2.5t2.5 5.9h-3.4z m6.6 0q0-4.8-3.4-8.2t-8.2-3.4v-3.4q6.3 0 10.6 4.4t4.4 10.6h-3.4z m1.8 5.9q0.7 0 1.1 0.4t0.5 1.2v5.9q0 0.7-0.5 1.1t-1.1 0.5q-11.8 0-20.1-8.3t-8.3-20.1q0-0.7 0.5-1.1t1.1-0.5h5.9q0.7 0 1.2 0.5t0.4 1.1q0 3.2 1 6 0.3 1-0.4 1.7l-3.7 3.7q3.7 7.2 11 11l3.7-3.7q0.7-0.7 1.7-0.4 2.8 1 6 1z' })
        )
    );
};

exports.default = MdPhoneInTalk;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/phone-in-talk.js
// module id = 1826
// module chunks = 168707334958949